<script setup lang="ts">
const config = useRuntimeConfig();
const route = useRoute();

const { data: categories } = await useFetch<ArtworkCategory[]>("/api/artwork-categories");

useHead({
  title: "Artworks",
});
onMounted(() => {
});
</script>
<template>
  <div class="content">
    <!-- Breadcrumb area start -->
    <Breadcumb :title="'Artworks'" :subtitle="'A collection of my artworks.'" :items="[{ text: 'Home', href: '/' }]" :to="{ text: 'Artworks', href: '/artworks' }" />
    <!-- Breadcrumb area end -->

    <CategoryArtworksGrid />
  </div>
</template>
